import { Box } from "@mui/material";
import React from "react";
import Header from "../SharedComponents/Header/Header";
import LoginGuard from "../SharedComponents/LoginGuard/loginGuard";
import { environment } from "../utils/environment";
import { SelfInviteController, SelfInviteControllerDelegate } from "./controller";
import styles from './styles.module.css';

interface InternalState {
  notiStr?: string | null;
}

export default class SelfInvite extends React.PureComponent<{}, InternalState> implements SelfInviteControllerDelegate {
  private controller: SelfInviteController;

  constructor(props: any) {
    super(props);
    this.controller = new SelfInviteController(this);
    this.state = {
      notiStr: null,
    };
  }

  inviteFailed() {
    this.setRedirectingText("Erro ao aceitar convite!")
    window.location.href = decodeURIComponent(environment.baseUrl);
  }

  inviteSuccess() {
    this.setRedirectingText("Convite aceito com sucesso! Redirecionando...")
    window.location.href = decodeURIComponent(`${environment.baseUrl}`);
  }

  setRedirectingText(value: string | null) {
    this.setState({
      notiStr: value,
    });
  }

  componentDidMount(): void {
    const query = window.location.search,
          params = new URLSearchParams(query),
          token = params.get("invite_token")!,
          accessToken = localStorage.getItem("AccessToken");

    if (accessToken) 
      this.controller.registerInvite(token, accessToken)
  }

  redirecting() {
    if (this.state.notiStr)
      return (<div className={ styles.redir }>{ this.state.notiStr }</div>);
    else
      return (null);
  }

  render() {
    return (
      <Box
      display="flex"
      flexDirection="column"
      width="100%"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      >
      <LoginGuard /> 
        <Header logoutEnabled={false}/>
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <center>
            <div className={ styles.loader } />
            { this.redirecting() }
          </center>
        </div>
      </Box>
    )
  }
}
